import Player from "@/components/Player/Player";
import { flaglerPierCamera, flaglerSurfCamera } from "@/lib/flaglerLandings";
import { Box, Typography } from "@mui/material";

export default function FlaglerCamPlayers() {
  const pier = flaglerPierCamera();
  const surfCam = flaglerSurfCamera();

  return (
    <Box sx={{ display: "grid", gap: 1.5, mt: 1 }}>
      {pier ? (
        <Box>
          <Typography
            sx={{
              color: "text.secondary",
              fontSize: "0.78rem",
              textTransform: "uppercase",
              letterSpacing: 0,
              mb: 0.75,
            }}
          >
            Flagler Beach Pier cam
          </Typography>
          <Player
            index={0}
            name={pier.name}
            url={pier.url}
            camera={pier}
            availableCameras={[pier]}
            canDelete={false}
            onCameraChange={() => undefined}
            onDelete={() => undefined}
          />
        </Box>
      ) : null}
      {surfCam?.kind === "link" ? (
        <Player
          index={1}
          name={surfCam.name}
          url={surfCam.url}
          camera={surfCam}
          availableCameras={[surfCam]}
          canDelete={false}
          onCameraChange={() => undefined}
          onDelete={() => undefined}
        />
      ) : null}
    </Box>
  );
}
